import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FEATURE_NAME, reducer } from './review-data.reducer';
import { ReviewDataEffects } from './review-data.effects';
import { ReviewDataService } from './review-data.service';
import { ReviewDataStore } from './review-data.store';
import { ReviewDataDispatcher } from './review-data.dispatcher';
import { ReviewRequestDataResolve } from './resolvers';
import { ReviewDataBuilder } from './review-data.builder';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ReviewDataEffects]),
    StoreModule.forFeature(FEATURE_NAME, reducer),
  ],
  declarations: [],
})
export class ReviewDataModule {
  static forRoot(): ModuleWithProviders<ReviewDataModule> {
    return {
      ngModule: ReviewDataModule,
      providers: [
        ReviewDataService,
        ReviewDataStore,
        ReviewDataDispatcher,
        ReviewRequestDataResolve,
        ReviewDataBuilder,
      ],
    };
  }
}
